module.exports = __webpack_public_path__ + "img/GY.2ecaea30.svg";